import {Injectable} from '@angular/core';
import {environment as localEnvironment} from '../../environments/environment';
import {environment as productionEnvironment} from '../../environments/environment.prod';

@Injectable()
export class RouterUtilityService {

    constructor() {
    }

    navigateIfUnauthorized() {
        const env = localEnvironment || productionEnvironment;
        let url = window.location.href;
        if (!url.includes('toAuth=true')) {
            if (url.includes('?')) {
                url += '&toAuth=true';
            } else {
                url += '?toAuth=true';
            }
        }

        localStorage.removeItem('session');
        window.location.href = env.baseUrl.usm.frontEnd + 'authenticate?redirected_url='
            + url;
    }


    getUrlParameterByName(name, url) {
        name = name.replace(/[\[\]]/g, '\\$&');
        const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) {
            return null;
        }
        if (!results[2]) {
            return '';
        }
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }
}
